/**
 * @class Oskari.mapframework.bundle.maplegend.MapLegendBundle
 *
 * Bundle to add Map Layer Legends to application.
 *
 */
Oskari.clazz.define("Oskari.mapframework.bundle.maplegend.MapLegendBundle", function () {}, {
  "create": function create() {
    var me = this;
    var inst = Oskari.clazz.create("Oskari.mapframework.bundle.maplegend.MapLegendBundleInstance");
    return inst;
  },
  "update": function update(manager, bundle, bi, info) {}
}, {
  "protocol": ["Oskari.bundle.Bundle", "Oskari.mapframework.bundle.extension.ExtensionBundle"],
  "source": {
    "scripts": [{
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/instance.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/Flyout.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/Tile.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/publisher/MapLegendTool.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/plugin/MapLegendPlugin.js"
    }, {
      "type": "text/css",
      "src": "../../../../bundles/framework/maplegend/resources/scss/style.scss"
    }],
    "locales": [{
      "lang": "hy",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/hy.js"
    }, {
      "lang": "bg",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/bg.js"
    }, {
      "lang": "cs",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/cs.js"
    }, {
      "lang": "da",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/da.js"
    }, {
      "lang": "de",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/de.js"
    }, {
      "lang": "en",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/en.js"
    }, {
      "lang": "es",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/es.js"
    }, {
      "lang": "et",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/et.js"
    }, {
      "lang": "et",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/et.js"
    }, {
      "lang": "fi",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/fi.js"
    }, {
      "lang": "fr",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/fr.js"
    }, {
      "lang": "ka",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/ka.js"
    }, {
      "lang": "el",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/el.js"
    }, {
      "lang": "hr",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/hr.js"
    }, {
      "lang": "hu",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/hu.js"
    }, {
      "lang": "is",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/is.js"
    }, {
      "lang": "it",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/it.js"
    }, {
      "lang": "lv",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/lv.js"
    }, {
      "lang": "nb",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/nb.js"
    }, {
      "lang": "nl",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/nl.js"
    }, {
      "lang": "nn",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/nn.js"
    }, {
      "lang": "nn",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/nn.js"
    }, {
      "lang": "pl",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/pl.js"
    }, {
      "lang": "pt",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/pt.js"
    }, {
      "lang": "ro",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/ro.js"
    }, {
      "lang": "sr",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/sr.js"
    }, {
      "lang": "sl",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/sl.js"
    }, {
      "lang": "sk",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/sk.js"
    }, {
      "lang": "sq",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/sq.js"
    }, {
      "lang": "sv",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/sv.js"
    }, {
      "lang": "uk",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/uk.js"
    }, {
      "lang": "ru",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/maplegend/resources/locale/ru.js"
    }]
  },
  "bundle": {
    "manifest": {
      "Bundle-Identifier": "maplegend",
      "Bundle-Name": "maplegend",
      "Bundle-Author": [{
        "Name": "jjk",
        "Organisation": "nls.fi",
        "Temporal": {
          "Start": "2012"
        },
        "Copyleft": {
          "License": {
            "License-Name": "EUPL",
            "License-Online-Resource": "http://www.paikkatietoikkuna.fi/license"
          }
        }
      }],
      "Bundle-Name-Locale": {
        "fi": {
          "Name": " style-1",
          "Title": " style-1"
        },
        "en": {}
      },
      "Bundle-Version": "1.0.0",
      "Import-Namespace": ["Oskari", "jquery"],
      "Import-Bundle": {}
    }
  },
  /**
   * @static
   * @property dependencies
   */
  "dependencies": ["jquery"]
});
Oskari.bundle_manager.installBundleClass("maplegend", "Oskari.mapframework.bundle.maplegend.MapLegendBundle");
import '../../../../bundles/framework/maplegend/instance.js'
import '../../../../bundles/framework/maplegend/Flyout.js'
import '../../../../bundles/framework/maplegend/Tile.js'
import '../../../../bundles/framework/maplegend/publisher/MapLegendTool.js'
import '../../../../bundles/framework/maplegend/plugin/MapLegendPlugin.js'
import '../../../../bundles/framework/maplegend/resources/scss/style.scss'